import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Delete, Pencil } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { Automation } from 'modules/automations/store/models/Automation'

import { useCurrentAutomationRoute } from './currentRoute'

interface Props {
  automation: Automation
}

const Header = ({ automation }: Props) => {
  const navigate = useNavigate()

  const route = useCurrentAutomationRoute()

  return (
    <ResourceHeader
      title={automation.attributes.name}
      secondaryActions={[
        {
          icon: Delete,
          label: i18n.t('common.delete'),
          variant: 'critical',
          onClick: () => {
            navigate(
              route.delete.fullPath({
                id: automation.attributes.id,
              })
            )
          },
        },
        {
          icon: Pencil,
          label: i18n.t('automations.automation.rename.edit'),
          onClick: () => {
            navigate(
              route.rename.fullPath({
                id: automation.attributes.id,
              })
            )
          },
        },
      ]}
    />
  )
}

export default Header
